import util from '../util'

let controller = 'CadastroMenorDeIdade'
export default Object.assign({}, util.GetCrud(controller, null), {
  OnboardingValidacaoBasica: function(documentoFederal, nome, codigoParceiro) {
    return util.Axios.Get(controller + `/Onboarding/ValidacaoBasica?nome=${encodeURIComponent(nome)}&documentoFederal=${documentoFederal}&codigoParceiro=${codigoParceiro}`)
  },
  RecusarValidacaoBasica: function (codigoCadastroMenor) {
    console.log(codigoCadastroMenor)
    return util.Axios.Patch(controller + `/Onboarding/ValidacaoBasica/Recusar?codigoCadastroMenor=${codigoCadastroMenor}`)
  }
})
